import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, SunIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-81" data-mp="sa9szg4tfxxp">
      <div className="h-1 w-full bg-primary" aria-hidden="true" data-id="element-82" data-mp="ncq1hej3xont" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-83" data-mp="neazje4mrpqf">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-primary/50 bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground" data-id="element-84" data-mp="3czfl7z4xc761">
          <SunIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-85" data-mp="399jmzcfv4d5l" /> {productBrand}
        </motion.p>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-86" data-mp="3e7ux7oa2kpoc">
          <img src={productImage} alt="Solar Energy & Photovoltaic Systems Professional Edition: six volumes and five bonus resources covering fundamentals, components, system design, installation, maintenance and advanced solar applications" className="mx-auto w-full drop-shadow-2xl" data-id="element-87" data-mp="2qkwk90l5rzv6" />
        </motion.div>

        <div className="mt-9" data-id="element-88" data-mp="2ljgyf6b5ppbq">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-89" data-mp="2lmuz8a469qh2">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-90" data-mp="na9zwokqxekx">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/30 bg-surface px-3 py-2" data-id="element-91" data-mp="ddf0m3gnfa5l">
              <Icon className="h-3.5 w-3.5 text-primary" aria-hidden="true" data-id="element-92" data-mp="1azku1n7lcaq3" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}